/**
 * Shared constants for wedding website layouts.
 * Centralizes magic numbers used across split and primary layouts.
 */

/** Height of the full-page preview modal header */
export const FULL_PAGE_PREVIEW_HEADER_HEIGHT = '81px';

/** Photo carousel image dimensions - Split layout (desktop only, mobile is dynamic) */
export const CAROUSEL_IMAGE = {
  /** Desktop split layout carousel (60% left panel) */
  desktop: { width: 864, height: 931 },
} as const;

/** Venue carousel image dimensions */
export const VENUE_CAROUSEL_IMAGE = {
  width: 500,
  height: 333,
} as const;

/** Autoplay intervals for carousels (ms) */
export const AUTOPLAY_INTERVAL = {
  default: 4000,
  venue: 4000,
} as const;
